import React from 'react';

export const OnScreenContext = React.createContext(true);
